module.exports = __webpack_public_path__ + "img/profile-circle.8e20d5d1.svg";